import React from 'react';

interface ResultsIconProps {
  size?: number;
  className?: string;
}

const ResultsIcon: React.FC<ResultsIconProps> = ({ size = 18, className = '' }) => {
  const aspectRatio = 15 / 16;
  const width = size * aspectRatio;
  const height = size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
      className={className}
    >
      <path
        d="M14.0062 5.83529C13.8656 2.56 11.1749 0 7.94056 0C4.70619 0 2.01556 2.56 1.87494 5.83529C1.81869 7.13412 2.17494 8.34824 2.81244 9.36471C2.96244 9.59059 3.27181 9.63765 3.48744 9.46824C3.70306 9.30824 3.74056 8.99765 3.59994 8.76235C3.08431 7.92471 2.81244 6.92706 2.84994 5.87294C2.96244 3.12471 5.22181 0.978823 7.93119 0.978823C10.6406 0.978823 12.8999 3.12471 13.0124 5.87294C13.0593 6.92706 12.7781 7.92471 12.2624 8.76235C12.1218 8.99765 12.1593 9.29882 12.3749 9.46824C12.5906 9.62824 12.8999 9.59059 13.0499 9.36471C13.6968 8.34824 14.0437 7.13412 13.9874 5.83529H14.0062Z"
        fill="currentColor"
      />
      <path
        d="M8.61602 6.13696C8.50352 5.86402 8.23165 5.67578 7.94102 5.67578C7.6504 5.67578 7.37852 5.8546 7.26602 6.13696L3.6004 15.1723C3.4504 15.5487 3.72227 15.9534 4.1254 15.9534C4.35977 15.9534 4.56602 15.8123 4.6504 15.5958L5.4004 13.6946H10.491L11.241 15.5958C11.3254 15.8123 11.5316 15.9534 11.766 15.9534C12.1691 15.9534 12.441 15.5487 12.291 15.1723L8.6254 6.13696H8.61602ZM5.79415 12.6781L7.8754 7.3699V7.35108L7.94102 7.16284L7.99727 7.35108V7.3699L10.0879 12.6781H5.79415Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ResultsIcon;
